<script lang="ts" setup>
	import CatalogHeader from '@/components/CatalogHeader.vue';
	import {useProductTableStore} from '@/store/table.store';
	import {useWindowSize} from '@vueuse/core';
	import {storeToRefs} from 'pinia';
	import {onMounted} from 'vue';
	import {RouterView} from 'vue-router';
	import {useAppStore} from '@/store/app.store';

	const {width} = useWindowSize();
	const {loading} = storeToRefs(useProductTableStore());
	const appStore = useAppStore();
	const {substituteModalActive, exportModalActive, filterBlockActive, filterExpanded, confirmClearFavoritesModalActive} = storeToRefs(appStore);

	onMounted(() => {
		if (width.value < 959) {
			appStore.setFilterBlockActive(false);
		}
	});
</script>

<template>
	<div :class="{'hide': !loading}" class="blockingOverlay"></div>

	<div :class="{
		'catalog-init-is-ready': !loading,
		'show-substitute-modal': substituteModalActive,
		'show-catalog-export-modal': exportModalActive,
		'show-confirm-clear-favorites-modal': confirmClearFavoritesModalActive,
		'catalog-is-loading': loading,
		'hide-filters': !filterBlockActive,
		'filter-part-options-active': filterExpanded,
		'show-filters': filterBlockActive
	}"
	     class="availability-wrapper">

		<CatalogHeader />

		<div class="catalog-body">
			<div class="catalog-body__inner">
				<RouterView />
			</div>
		</div>
	</div>
</template>
